module.exports = "pegasus/assets/themelp1/app/101.png";